module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Arm Sofa_Caramel.ca01340f.png";